import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';

/**
 * Channel for every driver alert - FCM pushes and local notifications alike.
 * Also referenced from AndroidManifest.xml as
 * `default_notification_channel_id`; keep both in sync.
 *
 * Importance and sound are frozen at creation, so changing either needs a new
 * id (`_v2`, ...). USAGE_ALARM was tried to survive silent mode and is ignored
 * by Samsung, hence NotificationVolumeWarning instead.
 */
export const DRIVER_ALERTS_CHANNEL_ID = 'driver_alerts_v1';

/** Custom sound, relative to `android/app/src/main/res/raw`. */
const DRIVER_ALERTS_CHANNEL_SOUND = 'driver_alert.wav';

/** `5` = IMPORTANCE_HIGH: shows a heads-up banner and plays a sound. */
const IMPORTANCE_HIGH = 5;

/**
 * Android only, no-op elsewhere. Safe to call on every app start - once the
 * channel exists only its name is still updatable.
 */
export const createDriverAlertsChannel = async (
	name: string
): Promise<void> => {
	if (Capacitor.getPlatform() !== 'android') {
		return;
	}

	await LocalNotifications.createChannel({
		id: DRIVER_ALERTS_CHANNEL_ID,
		name,
		importance: IMPORTANCE_HIGH,
		sound: DRIVER_ALERTS_CHANNEL_SOUND,
		vibration: true,
		visibility: 1,
	});
};
